import { ITeaser } from '@seb/web-design-system/teaser';
import { ThemesEnum } from '@seb/web-design-system/core';

import { richParagraphSkeleton } from './rich-paragraph.skeleton';

export const teaserSkeleton: ITeaser = {
  media: undefined,
  content: richParagraphSkeleton,
  themesConfig: ThemesEnum.light
};
